import { useParams } from 'react-router-dom';
import CaseStudyDetail from '../components/CaseStudyDetail';
import { getCaseStudy } from '../content/caseStudies';
import NotFoundPage from './NotFoundPage';
import ContactSection from '../components/ContactSection';

/**
 * Case study route. Pulls the matching study by slug; falls back to 404 if
 * none matches.
 */
export default function CaseStudyPage() {
  const { slug } = useParams();
  const study = getCaseStudy(slug);

  if (!study) return <NotFoundPage />;

  return (
    <>
      <CaseStudyDetail study={study} />
      <ContactSection />
    </>
  );
}
